export default (state, newState) => newState;
